import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch("https://api.backofficemain.com/login_staff.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();
      setLoading(false);

      if (data.success) {
        localStorage.setItem("staffData", JSON.stringify(data.staff));
        window.location.href = "/admin-dashboard";
      } else {
        setError(data.message || "Invalid username or password.");
      }
    } catch (err) {
      setError("Server connection error.");
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{
        backgroundColor: "#0d1b2a", // warna senada sidebar
      }}
    >
      <div
        className="card shadow-lg border-0 rounded-4"
        style={{
          width: "50%",             // 🔹 Lebar fix 50% layar
          minWidth: "50%",          // 🔹 Minimal 50%
          maxWidth: "50%",          // 🔹 Maksimal 50%
          backgroundColor: "#ffffff",
        }}
      >
        {/* Header */}
        <div
          className="card-header text-center text-white fw-bold fs-5"
          style={{
            backgroundColor: "#1b263b",
            borderTopLeftRadius: "0.75rem",
            borderTopRightRadius: "0.75rem",
          }}
        >
          Admin Login
        </div>

        {/* Body */}
        <div className="card-body p-4">
          {error && (
            <div className="alert alert-danger text-center py-2">{error}</div>
          )}
          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label className="form-label fw-semibold">Username</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                style={{
                  backgroundColor: "#e9f1ff",
                }}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  backgroundColor: "#e9f1ff",
                }}
                required
              />
            </div>

            <div className="d-grid mt-3">
              <button
                type="submit"
                className="btn text-white fw-semibold py-2"
                style={{
                  backgroundColor: "#1b263b",
                  transition: "0.2s",
                }}
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </button>
            </div>
          </form>
        </div>

        {/* Footer */}
        <div
          className="card-footer text-center text-muted small"
          style={{
            backgroundColor: "#f8f9fa",
            borderBottomLeftRadius: "0.75rem",
            borderBottomRightRadius: "0.75rem",
          }}
        >
          © {new Date().getFullYear()} Admin System
        </div>
      </div>
    </div>
  );
}

export default Login;
